export default __webpack_public_path__ + "static/Wool-17d5b81799baf4061f9ecffce5b8b35a.png";